import React, { Dispatch, FC, SetStateAction } from 'react'
import { Box, IconButton, SxProps, TextField, Theme } from '@mui/material'
import SearchSmallIcon from '../svg/SearchSmallIcon'
import ClearSvg from '../svg/ClearSvg'
import { SearchInputWrapper } from './styles/SearchInput.styles'

interface Props {
  search: string
  placeholder: string
  setSearch: Dispatch<SetStateAction<string>>
  sx?: SxProps<Theme>
}

const SearchInput: FC<Props> = ({ search, placeholder, setSearch, sx }) => {
  const inputHandler = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    setSearch(e.target.value)
  }

  return (
    <SearchInputWrapper sx={sx}>
      <Box className="search-icon">
        <SearchSmallIcon />
      </Box>
      <TextField
        className="search-bar"
        value={search}
        placeholder={placeholder || 'Search'}
        onInput={(e) => inputHandler(e)}
        onKeyDown={(e) => e.stopPropagation()}
      />
      {search ? (
        <IconButton className="clear-btn" onClick={() => setSearch('')}>
          <ClearSvg />
        </IconButton>
      ) : (
        ''
      )}
    </SearchInputWrapper>
  )
}

export default SearchInput
